import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdBuild, IoMdCheckmarkCircleOutline, IoMdListBox, IoMdTrophy } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import PartnersBanner from "../ones/PartnersBanner";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-12">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "capitalize",
											}}
										>
											Our Services
										</h1>
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				<ServicesBanner1/>
				<div className="MainBodySection mb-5">
					<div className="container">
											<div className="row">
												<div className="col-md-12">
													<h3 className="text-primary font-semi-bold">
														Our Unique Strengths
													</h3>
												</div>
					
												<div className="col-md-12 mt-3" data-aos="fade-right">
													<div className="row bg-secondary pb-3">
														<div 
															className="col-md-2 flex-shrink-0 pt-3"
															style={{
																display: "grid",
																placeItems: "center"
															}}
													>
															<IoMdTrophy size={68} />
														</div>
														<div className="col-md-10">
															<h5 className="text-center font-semi-bold mt-3">
																GOAL AND EXPERTISE
															</h5>
															<hr/>
															<h5
																style={{
																	textAlign: "justify"
																}}
															>
																We always bring fresh and innovative approach to consulting services. Our goal is to exceed the expectations of every client by offering outstanding services, increased flexibility, and greater value, thus optimizing our functionality and improving operational efficiency.  Our firm and associates are distinguished by their functional and technical expertise combined with their hands-on experience, thereby ensuring that our clients receive the most effective and professional attention. 
															</h5>
														</div>
													</div>
												</div>
					
												<div className="col-md-12 mt-3" data-aos="fade-right">
													<div className="row bg-secondary pb-3">
														<div 
															className="col-md-2 flex-shrink-0 pt-3"
															style={{
																display: "grid",
																placeItems: "center"
															}}
													>
															<IoMdListBox size={68} />
														</div>
														<div className="col-md-10">
															<h5 className="text-center font-semi-bold mt-3">
																CLIENT NEEDS
															</h5>
															<hr/>
															<h5
																style={{
																	textAlign: "justify"
																}}
															>
																Our extensive skills encompass all aspects of implementation and operation, including business requirements definition, development of well-designed needs for client approval, design, and overseeing development teams customizing <i>‘knowledge’</i> to fit specific client needs on-site.
															</h5>
														</div>
													</div>
												</div>
					
												<div className="col-md-12 mt-3" data-aos="fade-right">
													<div className="row bg-secondary pb-3">
														<div 
															className="col-md-2 flex-shrink-0 pt-3"
															style={{
																display: "grid",
																placeItems: "center"
															}}
													>
															<IoMdBuild size={68} />
														</div>
														<div className="col-md-10">
															<h5 className="text-center font-semi-bold mt-3">
																PROJECT IMPLEMENTATION
															</h5>
															<hr/>
															<h5
																style={{
																	textAlign: "justify"
																}}
															>
																We pride ourselves on our proven track record for effectively administering multiple implementations that are met within budget restraints and time schedules. 
															</h5>
														</div>
													</div>
												</div>
					
												<div className="col-md-12 mt-3" data-aos="fade-right">
													<div className="row bg-secondary pb-3">
														<div 
															className="col-md-2 flex-shrink-0 pt-3"
															style={{
																display: "grid",
																placeItems: "center"
															}}
													>
															<IoMdCheckmarkCircleOutline size={68} />
														</div>
														<div className="col-md-10">
															<h5 className="text-center font-semi-bold mt-3">
																VALUES & KNOWLEDGE
															</h5>
															<hr/>
															<h5
																style={{
																	textAlign: "justify"
																}}
															>
																We maintain an extensive knowledge base of qualified consultants who excels in intellectual honesty and integrity, high client focus-customer service and reporting.    
															</h5>
														</div>
													</div>
												</div>
					
					
											</div>
										</div>
				</div>
				<PartnersBanner/>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}